import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { Pagination, Skeleton, Typography } from "@mui/material";
import RowContainer from "../../../common/RowContainer.js";
import ColumnContainer from "../../../common/ColumnContainer.js";
import { useGetTicketsByAdminIdQuery } from "../../../../redux/features/tickets/ticketsApi.js";
import { TitleContainer, Wrapper } from "../../style.js";
import {
  changePageNumberTickets,
  getTicketsList,
} from "../../../../redux/features/tickets/ticketsSlice.js";
import TicketsList from "./TicketsList.js";
import { useAuth } from "../../../../utils/hooks/useAuth.js";
import { FormattedMessage } from "react-intl";
import { SkeletonLoading } from "../../../common/SkeletonLoading.js";
import { ErrorLoading } from "../../../common/ErrorLoading.js";

export default function TicketsPage() {
  // INIT
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  const auth = useAuth();

  // STATE
  const [filters, setFilters] = useState({
    ticket_status: null,
    category: null,
    company_name: null,
    updated_at: null,
    created_at: null,
  });
  const [currentPage, setCurrentPage] = useState(1);

  // FUNCTIONS

  const handleFilterStateChange = (value) => {
    setFilters(value);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    dispatch(changePageNumberTickets(value));
  };

  const handleCurrentPageChange = (value) => {
    setCurrentPage(value);
  };

  // REDUX
  const pageNumber = useSelector(
    (state) => state?.tickets?.ticketsList?.pagination?.pageNumber
  );

  const adminId = auth?.auth?.userData?.admin_id;

  const { data, isLoading, isError } = useGetTicketsByAdminIdQuery(
    {
      adminId: adminId,
      page: currentPage,
      queryFilters: filters,
    },
    {
      skip: !adminId,
    }
  );

  // EFFECTS
  useEffect(() => {
    if (data && !isLoading && !isError) {
      dispatch(getTicketsList(data));
    }
  }, [data, pageNumber, isLoading, isError, dispatch]);

  // UTILS
  const tableHeaders = [
    // "Id",
    <FormattedMessage id="table.header.status" />,
    <FormattedMessage id="table.header.category" />,
    <FormattedMessage id="table.header.companyName" />,
    <FormattedMessage id="table.header.created" />,
    <FormattedMessage id="table.header.updated" />,
    <FormattedMessage id="table.header.title" />,
    <FormattedMessage id="table.header.details" />,
  ];

  return (
    <Wrapper>
      {id ? (
        <Outlet />
      ) : (
        <ColumnContainer style={{ height: "100vh" }}>
          <ColumnContainer>
            <TitleContainer>
              <Typography variant="h3" component="h3">
                Tickets
              </Typography>
            </TitleContainer>
            {isLoading ? (
              <SkeletonLoading />
            ) : isError ? (
              <ErrorLoading />
            ) : (
              <TicketsList
                tableHeaders={tableHeaders}
                tickets={data || []}
                paginationData={data?.pagination}
                notFilteredTickets={data?.not_filtered_tickets || []}
                onFilterStateChange={handleFilterStateChange}
                onTicketsPageChange={handleCurrentPageChange}
              />
            )}
          </ColumnContainer>
          <RowContainer center>
            {data?.pagination ? (
              <Pagination
                count={data?.pagination?.total_pages}
                page={data?.pagination?.active_page}
                onChange={handlePageChange}
              />
            ) : null}
          </RowContainer>
        </ColumnContainer>
      )}
    </Wrapper>
  );
}
